import * as z from "zod";

export const getStayAiConnectionStatus = {
  name: "getStayAiConnectionStatus" as const,
  input: z.object({}),
  output: z.object({ connected: z.boolean() }),
};
